module.exports = __webpack_public_path__ + "img/magic.8ccbebec.svg";